module.exports = __webpack_public_path__ + "img/134.6cdeab8a.jpg";